export default function PayrollDisFileIcon() {
  return (
    <>
      <svg
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="70" height="70" rx="35" fill="#F2F5FF" />
        <path
          d="M37.8124 23.75H26.5615C26.3129 23.75 26.0744 23.8488 25.8986 24.0246C25.7228 24.2004 25.624 24.4389 25.624 24.6875V45.3125C25.624 45.5611 25.7228 45.7996 25.8986 45.9754C26.0744 46.1512 26.3129 46.25 26.5615 46.25H43.4374C43.5606 46.25 43.6825 46.2258 43.7962 46.1786C43.9099 46.1315 44.0133 46.0625 44.1004 45.9754C44.1874 45.8884 44.2565 45.785 44.3036 45.6713C44.3507 45.5575 44.3749 45.4356 44.3749 45.3125V30.3125M37.8124 23.75L44.3749 30.3125M37.8124 23.75V30.3125H44.3749M31.2499 39.6875H38.7499M31.2499 35.9375H38.7499"
          stroke="#1B4DFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
